<script lang="ts">
  import {Language, selectedLanguage} from '../../stores/language';
  import {router} from 'yrv';
  import Button from '../button/Button.svelte';

  // Update selectedLanguage on route change when language param is set
  router.subscribe(router => {
    const {language} = router.query;

    if (!language) {
      return;
    }

    selectedLanguage.update(() =>
      language === Language.EN ? Language.EN : Language.DE
    );
  });

  const options = Object.values(Language).map(language => {
    return {
      value: language,
      label: language
    };
  });

  const toggleLanguage = (event: Event) => {
    event.preventDefault();

    selectedLanguage.update(language =>
      language === Language.EN ? Language.DE : Language.EN
    );
  };
</script>

<style lang="postcss">
  .language-switcher {
    display: flex;
    align-items: center;
    padding-inline: 0.25rem;
    gap: 0.25rem;
    margin-left: auto;
  }

  .language-switcher button {
    width: fit-content;
    background-color: transparent;
    color: var(--ubilabs-gray-dark-2);
    padding: .5rem .25rem;
    border: none;
    cursor: pointer;

    &.active, &:hover {
      text-decoration: underline;
    }
  }
</style>

<div class="language-switcher">
  {#each options as option}
    <button on:click={toggleLanguage} class={$selectedLanguage === option.value ? 'active' : ''}>
      {option.label.toUpperCase()}
    </button>
  {/each}
</div>
